import { render, staticRenderFns } from "./UnsolicitedCalleeEffect.vue?vue&type=template&id=35eb6ff7&scoped=true&"
import script from "./UnsolicitedCalleeEffect.vue?vue&type=script&lang=js&"
export * from "./UnsolicitedCalleeEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35eb6ff7",
  null
  
)

export default component.exports